var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.$store.state.newConfig.general.useSidebarSubnavigation && !_vm.$store.state.hideNav && (_vm.navItems.length || _vm.activeNavItems.length),
      expression: "!$store.state.newConfig.general.useSidebarSubnavigation && !$store.state.hideNav && (navItems.length || activeNavItems.length)"
    }],
    staticClass: "sub-bottom-bar",
    class: [{
      'sub-bottom-bar--stack': _vm.navItems.length > 8
    }, {
      'sub-bottom-bar--video-active': _vm.isReferenceVideoActive
    }]
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.navItems.length || _vm.activeNavItems.length,
      expression: "navItems.length || activeNavItems.length"
    }],
    staticClass: "sub-bottom-bar__wrapper"
  }, [_c('transition-group', {
    staticClass: "sub-bottom-bar__nav-items",
    class: [{
      'padding-level--0': _vm.navItems.length >= 15
    }, {
      'padding-level--1': _vm.navItems.length < 15 && _vm.navItems.length >= 13
    }, {
      'padding-level--2': _vm.navItems.length < 13 && _vm.navItems.length >= 11
    }],
    on: {
      "before-enter": _vm.beforeEnter,
      "enter": _vm.enter,
      "afterEnter": _vm.afterEnter,
      "leave": _vm.leave
    }
  }, _vm._l(_vm.activeNavItems, function (navItem, index) {
    return _c('div', {
      key: navItem._id,
      staticClass: "sub-bottom-bar__nav-item-wrapper",
      attrs: {
        "data-index": index,
        "data-id": navItem._id
      }
    }, [!_vm.isItemExternal(navItem) ? _c('router-link', {
      staticClass: "sub-bottom-bar__nav-button touch",
      class: {
        'router-link-active': _vm.isNavItemActive(navItem)
      },
      attrs: {
        "tag": "button",
        "to": _vm.getItemUrl(navItem),
        "dir": _vm.lang.dir
      },
      nativeOn: {
        "click": function click($event) {
          _vm.triggerMedia(navItem.label['en']);
          _vm.playClickSound();
          _vm.bus.$emit('navClick');
        }
      }
    }, [navItem.icon && navItem.icon[1] ? _c('div', {
      staticClass: "icon"
    }, [_c('fa', {
      attrs: {
        "icon": navItem.icon
      }
    })], 1) : _vm._e(), _c('div', {
      domProps: {
        "innerHTML": _vm._s(navItem.label[_vm.lang.code] || navItem.label['en'])
      }
    })]) : _vm._e(), _vm.isItemExternal(navItem) ? _c('button', {
      staticClass: "sub-bottom-bar__nav-button touch",
      attrs: {
        "tag": "button",
        "dir": _vm.lang.dir
      },
      on: {
        "click": function click($event) {
          return _vm.handleExternalLinkClick(navItem);
        }
      }
    }, [navItem.icon && navItem.icon[1] ? _c('div', {
      staticClass: "icon"
    }, [_c('fa', {
      attrs: {
        "icon": navItem.icon
      }
    })], 1) : _vm._e(), _c('div', {
      domProps: {
        "innerHTML": _vm._s(navItem.label[_vm.lang.code] || navItem.label['en'])
      }
    })]) : _vm._e()], 1);
  }), 0)], 1)])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }